module.exports = __webpack_public_path__ + "static/media/cloud-redo.c9d16b2b.svg";